//#region Imports
import GatewayAxiosClient from '../GatewayAxiosClient';
import type { RulePropertyInfo } from './types';
import type {
  PartnerRule,
  PartnerRuleCreate,
  PartnerRuleSet,
  PartnerRuleSetCreate,
  PartnerRuleSetUpdate,
  PartnerRuleUpdate,
} from '@shipium-corp/shipium-ts-types';
//#endregion

export class RuleSetServiceV2 {
  //#region Rule Set Service Methods
  public async fetchPartnerRuleSet(populateRules = true): Promise<PartnerRuleSet> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v1/partners/ruleSets/partnerRuleSet?populateRules=${populateRules}`,
    );
    return res.data;
  }

  public async createRuleSet(payload: PartnerRuleSetCreate): Promise<PartnerRuleSet> {
    const res = await GatewayAxiosClient.post(`/partner-management-proxy/api/v1/partners/ruleSets`, payload);
    return res.data;
  }

  public async fetchRuleSetById(ruleSetId: string): Promise<PartnerRuleSet> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/ruleSets/${ruleSetId}`);
    return res.data;
  }

  public async updateRuleSet({
    ruleSetId,
    payload,
  }: {
    ruleSetId: string;
    payload: PartnerRuleSetUpdate;
  }): Promise<PartnerRuleSet> {
    const res = await GatewayAxiosClient.put(
      `/partner-management-proxy/api/v1/partners/ruleSets/${ruleSetId}`,
      payload,
    );
    return res.data;
  }
  //#endregion

  //#region Rule Service Methods
  public async fetchRules(): Promise<PartnerRule[]> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/rules`);
    return res.data;
  }

  public async createRule(payload: PartnerRuleCreate): Promise<PartnerRule> {
    const res = await GatewayAxiosClient.post(`/partner-management-proxy/api/v1/partners/rules`, payload);
    return res.data;
  }

  public async fetchRulePropertyInfos(): Promise<RulePropertyInfo[]> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/rules/rulePropertyInfos`);
    return res.data;
  }

  public async fetchRuleById(ruleId: string): Promise<PartnerRule> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/rules/${ruleId}`);
    return res.data;
  }

  public async updateRule({ ruleId, payload }: { ruleId: string; payload: PartnerRuleUpdate }): Promise<PartnerRule> {
    const res = await GatewayAxiosClient.put(`/partner-management-proxy/api/v1/partners/rules/${ruleId}`, payload);
    return res.data;
  }
  //#endregion
}
